import './Plaque.css';
import plaqueImg from './plaque.png';

type PlaqueProps = {
  className?: string;
};

/**
 * Figma `background` (104:24185) — shared purple plaque asset.
 * Flattened PNG without DROP_SHADOW; shadow via CSS filter.
 * Position is owned by parent (tickets / rating buttons).
 */
export function Plaque({ className }: PlaqueProps) {
  return (
    <img
      className={['map-plaque', className].filter(Boolean).join(' ')}
      src={plaqueImg}
      alt=""
      draggable={false}
      aria-hidden
    />
  );
}
